module.exports = __webpack_public_path__ + "img/mc.14c9150f.svg";